module.exports = __webpack_public_path__ + "static/media/man-laptop-v1.f28cb247.svg";